import React from "react";
import {
  Box,
  Typography,
  Button,
  Stack,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  CardMedia,
} from "@mui/material";
import { FaCheckCircle } from "react-icons/fa";
// import Section10BImg from "./section10B.png";
import Section10BImg from "./Section10C.png";
import { TbCircleNumber1Filled } from "react-icons/tb";

const Section10B = ({ data, index }) => {
  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          // width: { xl: "72%", lg: "80%", md: "95%", sm: "94%" },
          width: { xl: "72%", lg: "89%", md: "89%", sm: "100%", xs: "92%" },
          alignItems: "center",
          justifyContent: { xl: "space-between", lg: "space-between" },
          // px: { xs: 2, md: 5 },
          py: { xs: 0, sm: 4 },
          border: { xs: "1px solid #ddd", sm: "none" },
          borderTopLeftRadius: { xs: "16px", sm: "0px" },
          borderTopRightRadius: { xs: "16px", sm: "0px" },
        }}
      >
        {/* <Box
          component="img"
          src={Section10BImg}
          // src= {ComponentData[index]?.section10B?.card_image}
          alt="Section 10B"
          sx={{
            flex: 1,
            width: { xs: "100%", md: "80%", xl: "60%" },
            maxWidth: "500px",
            display: { xs: "flex", sm: "none" },
            marginBottom: { xs: "28px", sm: "0px" },
            // border: "2px solid blue",
          }}
        /> */}

        <Box
          sx={{
            flex: 1,
            width: { xs: "100%", md: "80%", xl: "60%" },
            maxWidth: "500px",
            display: { xs: "flex", sm: "none" },
            marginBottom: { xs: "28px", sm: "0px" },
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
            overflow: "hidden",
            position: "relative",

            // Glassmorphism effect
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            border: "1px solid #ddd",
            boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",

            // Shimmer effect
            "&::after": {
              content: '""',
              position: "absolute",
              top: 0,
              left: "-150%",
              height: "100%",
              width: "150%",
              background:
                "linear-gradient(120deg, transparent, rgba(255,255,255,0.4), transparent)",
              animation: "shineEffect 2s infinite",
            },
            "@keyframes shineEffect": {
              "0%": { left: "-150%" },
              "50%": { left: "100%" },
              "100%": { left: "150%" },
            },
          }}
        >
          <Box
            component="img"
            // src={Section10BImg}
            src={data[index]?.use_case[0]?.img || Section10BImg}
            alt="Section 10B"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: 1,
            }}
          />
        </Box>

        {/* Text Content */}
        <Box
          sx={{
            maxWidth: { xs: "100%", md: "600px" },
            marginBottom: { xs: "0px", md: "0" },
            // border: "2px solid blue",
          }}
        >
          <Stack
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              paddingLeft: "32px", // optional padding
              marginBottom: "16px",
            }}
          >
            {/* #1 background label */}
            <Typography
              sx={{
                position: "absolute",
                top: {
                  xl: "-72px",
                  lg: "-72px",
                  md: "-62px",
                  sm: "-44px",
                  xs: "-36px",
                },
                left: {
                  xl: "-40px",
                  lg: "-40px",
                  md: "-32px",
                  sm: "0px",
                  xs: "0px",
                },
                fontSize: {
                  xl: "100px",
                  lg: "100px",
                  md: "80px",
                  sm: "60px",
                  xs: "50px",
                },
                color: "#e0e0e0", // light gray
                fontWeight: 700,
                zIndex: 1,
                userSelect: "none",
              }}
            >
              #1
            </Typography>

            {/* Title */}
            <Typography
              variant="h4"
              sx={{
                zIndex: 2,
                position: "relative",
                fontWeight: 700,
                lineHeight: {
                  lg: "32px",
                  xl: "32px",
                  md: "32px",
                  xs: "24px",
                  sm: "24px",
                },
                fontSize: {
                  lg: "28px",
                  xl: "28px",
                  md: "28px",
                  xs: "20px",
                  sm: "20px",
                },
                fontFamily: "'Roboto', sans-serif",
                color: "rgb(0, 0, 0)",
              }}
            >
              {/* Run Ads that Click to WhatsApp */}
              {data[index]?.use_case[0]?.title || "title"}
            </Typography>
          </Stack>

          <Typography
            variant="body1"
            sx={{
              marginBottom: { xs: "0px", sm: "16px" },
              lineHeight: {
                lg: "32px",
                xl: "32px",
                md: "20px",
                xs: "20px",
                sm: "20px",
              },
              // fontSize: "18px",
              fontSize: {
                lg: "24px",
                xl: "24px",
                md: "16px",
                xs: "16px",
                sm: "16px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: {
                lg: 400,
                xl: 400,
                xs: 400,
                sm: 400,
              },
              color: "rgb(0, 0, 0)",
              // paddingLeft: "12px",
              padding: { xs: "0px", sm: "12px" },
              paddingLeft: { xs: "12px", sm: "12px" },
              // paddingRight: "12px",
              // border: "1px solid red",
              borderRadius: { xs: "0px", sm: "8px" },
              display: {
                xl: "flex",
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "flex",
              },
              color: "gray",
              marginBottom: { xs: "12px", sm: "0px" },
            }}
          >
            {/* Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead
            generations & 2-3X Conversions Instantly! */}
            {data[index]?.use_case[0]?.description1 || "description1"}
            {/* {ComponentData[index]?.section10B?.card_head2} */}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              marginBottom: "32px",
              lineHeight: {
                lg: "32px",
                xl: "32px",
                md: "20px",
                xs: "20px",
                sm: "20px",
              },
              // fontSize: "18px",
              fontSize: {
                lg: "24px",
                xl: "24px",
                md: "16px",
                xs: "16px",
                sm: "16px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: {
                lg: 400,
                xl: 400,
                xs: 400,
                sm: 400,
              },
              color: "rgb(0, 0, 0)",
              // paddingLeft: "12px",
              padding: { xs: "0px", sm: "12px" },
              paddingLeft: { xs: "12px", sm: "12px" },
              // paddingRight: "12px",
              // border: "1px solid rgb(218 233 248)",
              borderRadius: { xs: "0px", sm: "8px" },
              display: {
                xl: "flex",
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "flex",
              },
              color: "gray",
            }}
          >
            {/* Run Ads from AiSensy, smartly segregate your leads and build Chatbot
            Flows to automate everything! */}
            {data[index]?.use_case[0]?.description2 || "description2"}
            {/* {ComponentData[index]?.section10B?.card_head3} */}
          </Typography>
        </Box>
        {/* Image Section */}
        <Box
          component="img"
          // src={Section10BImg}
          src={data[index]?.use_case[0]?.img || Section10BImg}
          alt="Section 10B"
          sx={{
            flex: 1,
            width: { xs: "100%", md: "80%", xl: "60%" },
            maxWidth: "500px",
            display: { xs: "none", sm: "flex" },
          }}
        />
      </Box>
    </Stack>
  );
};

export default Section10B;

// import { motion, useScroll } from "framer-motion";
// import { useRef, useEffect, useState } from "react";
// import Lenis from "@studio-freight/lenis";
// import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
// import Section10BImg from "./section10B.png";

// const Section10B = () => {
//   const section10BCards = [
//     {
//       id: 1,
//       label: "#1",
//       title: "Run Ads that Click to WhatsApp",
//       desc1:
//         "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
//       desc2:
//         "Run Ads from AiSensy, smartly segregate your leads and build Chatbot Flows to automate everything!",
//       img: Section10BImg,
//     },
//     {
//       id: 2,
//       label: "#2",
//       title: "Capture Leads with Smart Forms",
//       desc1: "Embed forms inside WhatsApp, instantly capture user intent.",
//       desc2: "Send qualified leads to CRM automatically!",
//       img: Section10BImg,
//     },
//     {
//       id: 3,
//       label: "#3",
//       title: "Automate Response via Chatbots",
//       desc1: "Handle 80% of queries with smart logic flows.",
//       desc2: "Drive support, salesand feedback in one place.",
//       img: Section10BImg,
//     },
//     {
//       id: 4,
//       label: "#4",
//       title: "Track Performance in Real-Time",
//       desc1: "See ad spends, leads, open rateand drop-offs live.",
//       desc2: "Improve instantly based on insights.",
//       img: Section10BImg,
//     },
//   ];

//   const container = useRef(null);
//   const { scrollYProgress } = useScroll({ target: container });
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const [scales, setScales] = useState([]);

//   useEffect(() => {
//     const lenis = new Lenis();
//     function raf(time) {
//       lenis.raf(time);
//       requestAnimationFrame(raf);
//     }
//     requestAnimationFrame(raf);
//   }, []);

//   useEffect(() => {
//     const unsubscribe = scrollYProgress.onChange(() => {
//       const newScales = section10BCards.map((_, i) => {
//         return 1 - (section10BCards.length - i) * 0.05 * scrollYProgress.get();
//       });
//       setScales(newScales);
//     });

//     return () => unsubscribe();
//   }, [scrollYProgress]);

//   if (isMobile) {
//     return (
//       <main ref={container} className="main">
//         {section10BCards.map((card, i) => (
//           <Stack
//             key={card.id}
//             sx={{
//               height: "100vh",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               position: "sticky",
//               top: "0px",
//             }}
//           >
//             <motion.div
//               style={{
//                 scale: scales[i] || 1,
//                 top: `calc(-5vh + ${i * 25}px)`,
//                 borderRadius: "16px",
//                 boxShadow: "0 4px 30px rgba(0,0,0,0.1)",
//                 height: "520px", // ✅ Fixed height for all cards
//                 width: "92%",
//                 padding: "24px",
//                 background: "#fff",
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "space-between",
//               }}
//             >
//               {/* Glass image */}
//               <Box
//                 sx={{
//                   width: "100%",
//                   height: "auto",
//                   borderRadius: "12px",
//                   overflow: "hidden",
//                   position: "relative",
//                   mb: 2,
//                   backgroundColor: "rgba(255,255,255,0.1)",
//                   backdropFilter: "blur(10px)",
//                   WebkitBackdropFilter: "blur(10px)",
//                   border: "1px solid rgba(255,255,255,0.2)",
//                   "&::after": {
//                     content: '""',
//                     position: "absolute",
//                     top: 0,
//                     left: "-150%",
//                     height: "100%",
//                     width: "150%",
//                     background:
//                       "linear-gradient(120deg, transparent, rgba(255,255,255,0.4), transparent)",
//                     animation: "shineEffect 2s infinite",
//                   },
//                   "@keyframes shineEffect": {
//                     "0%": { left: "-150%" },
//                     "50%": { left: "100%" },
//                     "100%": { left: "150%" },
//                   },
//                 }}
//               >
//                 <Box
//                   component="img"
//                   src={card.img}
//                   alt={card.title}
//                   sx={{
//                     width: "100%",
//                     height: "100%",
//                     objectFit: "cover",
//                   }}
//                 />
//               </Box>

//               {/* <Typography
//                 variant="h5"
//                 sx={{ fontWeight: 700, mb: 1, color: "#333" }}
//               >
//                 {card.label} {card.title}
//               </Typography>
//               <Typography variant="body1" sx={{ mb: 1, color: "gray" }}>
//                 {card.desc1}
//               </Typography>
//               <Typography variant="body1" sx={{ color: "gray" }}>
//                 {card.desc2}
//               </Typography> */}

//               <Box
//                 sx={{
//                   maxWidth: { xs: "100%", md: "600px" },
//                   marginBottom: { xs: "0px", md: "0" },
//                   // border: "2px solid blue",
//                 }}
//               >
//                 <Stack
//                   sx={{
//                     position: "relative",
//                     display: "flex",
//                     justifyContent: "flex-start",
//                     alignItems: "flex-start",
//                     paddingLeft: "32px", // optional padding
//                     marginBottom: "16px",
//                   }}
//                 >
//                   {/* #1 background label */}
//                   <Typography
//                     sx={{
//                       position: "absolute",
//                       top: {
//                         xl: "-72px",
//                         lg: "-72px",
//                         md: "-62px",
//                         sm: "-44px",
//                         xs: "-36px",
//                       },
//                       left: {
//                         xl: "-40px",
//                         lg: "-40px",
//                         md: "-32px",
//                         sm: "0px",
//                         xs: "0px",
//                       },
//                       fontSize: {
//                         xl: "100px",
//                         lg: "100px",
//                         md: "80px",
//                         sm: "60px",
//                         xs: "50px",
//                       },
//                       color: "#e0e0e0", // light gray
//                       fontWeight: 700,
//                       zIndex: 1,
//                       userSelect: "none",
//                     }}
//                   >
//                     #1
//                   </Typography>

//                   {/* Title */}
//                   <Typography
//                     variant="h4"
//                     sx={{
//                       zIndex: 2,
//                       position: "relative",
//                       fontWeight: 700,
//                       lineHeight: {
//                         lg: "32px",
//                         xl: "32px",
//                         md: "32px",
//                         xs: "24px",
//                         sm: "24px",
//                       },
//                       fontSize: {
//                         lg: "28px",
//                         xl: "28px",
//                         md: "28px",
//                         xs: "20px",
//                         sm: "20px",
//                       },
//                       fontFamily: "'Roboto', sans-serif",
//                       color: "rgb(0, 0, 0)",
//                     }}
//                   >
//                     {card.title}
//                   </Typography>
//                 </Stack>

//                 <Typography
//                   variant="body1"
//                   sx={{
//                     marginBottom: { xs: "0px", sm: "16px" },
//                     lineHeight: {
//                       lg: "32px",
//                       xl: "32px",
//                       md: "20px",
//                       xs: "20px",
//                       sm: "20px",
//                     },
//                     // fontSize: "18px",
//                     fontSize: {
//                       lg: "24px",
//                       xl: "24px",
//                       md: "16px",
//                       xs: "16px",
//                       sm: "16px",
//                     },
//                     fontFamily: "'Roboto', sans-serif",
//                     fontWeight: {
//                       lg: 400,
//                       xl: 400,
//                       xs: 400,
//                       sm: 400,
//                     },
//                     color: "rgb(0, 0, 0)",
//                     // paddingLeft: "12px",
//                     padding: { xs: "0px", sm: "12px" },
//                     paddingLeft: { xs: "12px", sm: "12px" },
//                     // paddingRight: "12px",
//                     // border: "1px solid red",
//                     borderRadius: { xs: "0px", sm: "8px" },
//                     display: {
//                       xl: "flex",
//                       lg: "flex",
//                       md: "flex",
//                       sm: "flex",
//                       xs: "flex",
//                     },
//                     color: "gray",
//                     marginBottom: { xs: "12px", sm: "0px" },
//                   }}
//                 >
//                   {/* Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your
//                   lead generations & 2-3X Conversions Instantly! */}
//                   {card.desc1}
//                   {/* {ComponentData[index]?.section10B?.card_head2} */}
//                 </Typography>
//                 <Typography
//                   variant="body1"
//                   sx={{
//                     marginBottom: "32px",
//                     lineHeight: {
//                       lg: "32px",
//                       xl: "32px",
//                       md: "20px",
//                       xs: "20px",
//                       sm: "20px",
//                     },
//                     // fontSize: "18px",
//                     fontSize: {
//                       lg: "24px",
//                       xl: "24px",
//                       md: "16px",
//                       xs: "16px",
//                       sm: "16px",
//                     },
//                     fontFamily: "'Roboto', sans-serif",
//                     fontWeight: {
//                       lg: 400,
//                       xl: 400,
//                       xs: 400,
//                       sm: 400,
//                     },
//                     color: "rgb(0, 0, 0)",
//                     // paddingLeft: "12px",
//                     padding: { xs: "0px", sm: "12px" },
//                     paddingLeft: { xs: "12px", sm: "12px" },
//                     // paddingRight: "12px",
//                     // border: "1px solid rgb(218 233 248)",
//                     borderRadius: { xs: "0px", sm: "8px" },
//                     display: {
//                       xl: "flex",
//                       lg: "flex",
//                       md: "flex",
//                       sm: "flex",
//                       xs: "flex",
//                     },
//                     color: "gray",
//                   }}
//                 >
//                   {/* Run Ads from AiSensy, smartly segregate your leads and build
//                   Chatbot Flows to automate everything! */}
//                   {card.desc2}
//                   {/* {ComponentData[index]?.section10B?.card_head3} */}
//                 </Typography>
//               </Box>
//             </motion.div>
//           </Stack>
//         ))}
//       </main>
//     );
//   }

//   // 👇 For desktop, return your original layout (already provided)
//   return <>{/* Your existing Section10B JSX remains unchanged */}</>;
// };

// export default Section10B;
